/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_SpecialtyInputs */

const en_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specialty sessions`)
};

const es_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones especializadas`)
};

const de_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spezialtrainings`)
};

const zh_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专项课程`)
};

const ar_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جلسات متخصصة`)
};

const fr_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances spécialisées`)
};

const vi_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi chuyên biệt`)
};

const sw_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vipindi maalum`)
};

const th_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เซสชันพิเศษ`)
};

const bs_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specijalne sesije`)
};

const ja_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特別セッション`)
};

const ko_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`특별 세션`)
};

const pt_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessões especiais`)
};

const it_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessioni speciali`)
};

const sv_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specialpass`)
};

const nl_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speciale sessies`)
};

const da_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specielle sessioner`)
};

const nb_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesialøkter`)
};

const fi_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erikoistunnit`)
};

const pl_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesje specjalne`)
};

const ru_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Специальные занятия`)
};

const tr_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel seanslar`)
};

const hi_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशेष सत्र`)
};

const id_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi khusus`)
};

const ms_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi istimewa`)
};

const cs_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speciální lekce`)
};

const el_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ειδικές συνεδρίες`)
};

const he_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מפגשים מיוחדים`)
};

const af_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesiale sessies`)
};

const hu_booking_specialty = /** @type {(inputs: Booking_SpecialtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Különleges órák`)
};

/**
* | output |
* | --- |
* | "Specialty sessions" |
*
* @param {Booking_SpecialtyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_specialty = /** @type {((inputs?: Booking_SpecialtyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_SpecialtyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_specialty(inputs)
	if (locale === "de") return de_booking_specialty(inputs)
	if (locale === "zh") return zh_booking_specialty(inputs)
	if (locale === "ar") return ar_booking_specialty(inputs)
	if (locale === "fr") return fr_booking_specialty(inputs)
	if (locale === "vi") return vi_booking_specialty(inputs)
	if (locale === "sw") return sw_booking_specialty(inputs)
	if (locale === "th") return th_booking_specialty(inputs)
	if (locale === "bs") return bs_booking_specialty(inputs)
	if (locale === "ja") return ja_booking_specialty(inputs)
	if (locale === "ko") return ko_booking_specialty(inputs)
	if (locale === "pt") return pt_booking_specialty(inputs)
	if (locale === "it") return it_booking_specialty(inputs)
	if (locale === "sv") return sv_booking_specialty(inputs)
	if (locale === "nl") return nl_booking_specialty(inputs)
	if (locale === "da") return da_booking_specialty(inputs)
	if (locale === "nb") return nb_booking_specialty(inputs)
	if (locale === "fi") return fi_booking_specialty(inputs)
	if (locale === "pl") return pl_booking_specialty(inputs)
	if (locale === "ru") return ru_booking_specialty(inputs)
	if (locale === "tr") return tr_booking_specialty(inputs)
	if (locale === "hi") return hi_booking_specialty(inputs)
	if (locale === "id") return id_booking_specialty(inputs)
	if (locale === "ms") return ms_booking_specialty(inputs)
	if (locale === "cs") return cs_booking_specialty(inputs)
	if (locale === "el") return el_booking_specialty(inputs)
	if (locale === "he") return he_booking_specialty(inputs)
	if (locale === "af") return af_booking_specialty(inputs)
	if (locale === "hu") return hu_booking_specialty(inputs)
	return en_booking_specialty(inputs)
});